import React, { useState } from "react";
import Swal from "sweetalert2";
import { UrlWs } from "../../utils/Global";

export const EliminarExcluido = ({ setUpdateProceso, participante }) => {
  const [cargandoDatos, setCargandoDatos] = useState(false);

  const eliminarExcluido = async () => {
    if (cargandoDatos === false) {
      setCargandoDatos(true);
      const url =UrlWs+
        "/participants/" +
        participante.id_participant;
      console.log("Fetch");
      console.log(url);
      await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((datos) => {
          if (datos.status == true) {
            setUpdateProceso(true);
            setCargandoDatos(false);
            const $ = window.jQuery;
            $("#m-eliminar-excluido").modal("hide");
            Swal.fire({
              title: "Listo",
              text: "Participante eliminado de lista de excluídos",
              icon: "success",
              confirmButtonText: "Ok",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "Ocurrió un error al eliminar",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        });
    }
  };
  return (
    <>
      <div
        className="modal fade "
        id="m-eliminar-excluido"
        tabIndex="-1 "
        aria-hidden="true "
      >
        <div className="modal-dialog modal-dialog-centered mw-900px ">
          <div className="modal-content">
            <div className="modal-header ">
              <h2>
                Confirmar eliminación exclusión de funcionario del proceso
              </h2>

              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
              >
                X
              </div>
            </div>
            <div className="modal-body py-lg-10 px-lg-10 ">
              <div className="row">
                <div className="col-lg-12 col-sm-12 col-md-6">
                  <span className="fw-bolder fs-5 mb-5">&nbsp;</span>
                  <div className="table-responsive">
                    <table className="table table-rounded table-striped border gy-7 gs-7">
                      <thead>
                        <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                          <th>Nombre</th>
                          <th>Rut</th>
                          <th>Dirección</th>
                          <th>Motivo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {participante != null ? (
                          <tr>
                            <td>{participante.officerName}</td>
                            <td>{participante.officerRut}</td>
                            <td>{participante.nameUmunicipal}</td>
                            <td>{participante.commentExclusion}</td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={3}></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-danger"
                  style={{ "margin-right": "10px" }}
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={eliminarExcluido}
                  className="btn btn-sm btn-primary px-6"
                >
                  {cargandoDatos
                    ? " Eliminando exclusión..."
                    : " Eliminar exclusión"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
